import { SELECTABLE_MODULES } from './selectModuleCatalog';

/**
 * Mapeia uma chave de módulo (ex.: 'concursos', 'enem', 'oab') para a classe
 * utilitária CSS `module-theme-{cor}` definida em `src/index.css`. Essa classe
 * sobrescreve os tokens semânticos (`--primary`, `--accent`, `--ring`, ...) no
 * wrapper raiz do `AppLayout`, fazendo com que componentes shadcn (Select,
 * Popover, Checkbox, etc.) herdem automaticamente a cor do módulo ativo.
 */
export function moduleThemeClass(moduleKey: string | null | undefined): string {
  if (!moduleKey) return 'module-theme-emerald';
  const card = SELECTABLE_MODULES.find((m) => m.key === moduleKey);
  return card ? `module-theme-${card.color}` : 'module-theme-emerald';
}
